/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { v4 as uuidv4 } from "uuid";
import { environment } from "../../../environments/environment";

@Injectable({
	providedIn: "root"
})
export class EnvironmentService {
	private _businessId: string = uuidv4();
	private _sessionId: string = uuidv4();

	/**
	 * Redirects the user to the login page if they are unauthorized.
	 */
	public unauthorizedRedirect() {
		window.location.href = `${environment.keycloakUrl}?redirect_uri=${environment.baseUrl}`;
	}

	/**
	 * Generates a new unique transaction ID.
	 *
	 * @returns A new UUID string.
	 */
	public getTransactionId(): string {
		return uuidv4();
	}

	/**
	 * Retrieves the business ID.
	 *
	 * @returns The business ID.
	 */
	public getBusinessId(): string {
		return this._businessId;
	}

	/**
	 * Sets the business ID.
	 *
	 * @param businessId - The ID of the business to set.
	 */
	public setBusinessId(businessId: string) {
		this._businessId = businessId;
	}

	/**
	 * Retrieves the current session ID.
	 *
	 * @returns The session ID.
	 */
	public getSessionId(): string {
		return this._sessionId;
	}

	/**
	 * Sets the session ID.
	 *
	 * @param sessionId - The session ID to be set.
	 */
	public setSessionId(sessionId: string) {
		this._sessionId = sessionId;
	}
}
